import React, { memo } from 'react';
import Skeleton from './Skeleton';

const ModalSkeleton = memo(function ModalSkeleton({ style = {} }) {
  return (
    <div
      aria-busy="true"
      style={{
        width: '100%',
        maxWidth: 520,
        background: '#FFFFFF',
        borderRadius: 16,
        padding: 24,
        boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
        border: '1.5px solid var(--border, #E5E7EB)',
        ...style,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <Skeleton variant="text" width={180} height={22} />
        <Skeleton variant="circular" width={28} height={28} />
      </div>

      <Skeleton variant="text" width="90%" height={14} style={{ marginBottom: 16 }} />
      <Skeleton variant="rectangular" width="100%" height={100} borderRadius={9} style={{ marginBottom: 20 }} />

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
        <Skeleton variant="rectangular" width={80} height={38} borderRadius={9} />
        <Skeleton variant="rectangular" width={110} height={38} borderRadius={9} />
      </div>
    </div>
  );
});

export default ModalSkeleton;
